<template>
  <b-modal
    id="modal-filters"
    size="lg"
    centered
    title="Filtros"
    title-class="font-18"
  >
    <div class="row">
      <div class="col-12 col-md-6">
        <b-form-group label="Status">
          <b-form-select
            v-model="status"
            size="sm"
            multiple
            :options="options"
          ></b-form-select>
        </b-form-group>
      </div>

      <div class="col-12 col-md-6">
        <b-form-group label="Status da Venda">
          <b-form-select
            v-model="status2"
            size="sm"
            multiple
            :options="options_sale"
          ></b-form-select>
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <b-form-group label="Risco da Venda - Min e Max">
          <div class="grid-iputs">
            <input
              v-model="risck[0]"
              type="number"
              size="lg"
              min="1"
              max="999"
              class="custom-select custom-select-sm"
              placeholder="Exemplo: 90"
              name="min-risck"
              id="min-risck"
            />
            <input
              v-model="risck[1]"
              type="number"
              size="lg"
              min="2"
              max="1000"
              class="custom-select custom-select-sm"
              placeholder="Exemplo: 900"
              name="min-risck"
              id="min-risck"
            />
          </div>
        </b-form-group>
      </div>
      <div class="col-12 col-md-6">
        <b-form-group label="Score Participantes - Min e Max">
          <div class="grid-iputs">
            <input
              v-model="score[0]"
              type="number"
              size="lg"
              min="1"
              max="99"
              class="custom-select custom-select-sm"
              placeholder="Exemplo: 9"
              name="score-user"
              id="score-user"
            />
            <input
              v-model="score[1]"
              type="number"
              size="lg"
              min="2"
              max="100"
              class="custom-select custom-select-sm"
              placeholder="Exemplo: 90"
              name="score-user"
              id="score-user"
            />
          </div>
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <b-form-group label="IP da Venda">
          <input
            v-model="ip"
            type="txt"
            size="lg"
            class="custom-select custom-select-sm"
            placeholder="Exemplo: 90"
            name="min-risck"
            id="min-risck"
          />
        </b-form-group>
      </div>
      <div class="col-12 col-md-6">
        <b-form-group label="HASH do Cartão">
          <input
            v-model="hash"
            type="text"
            size="lg"
            class="custom-select custom-select-sm"
            placeholder="Exemplo: 698dc1"
            name="min-risck"
            id="min-risck"
          />
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <b-form-group label="CPF da Compra">
          <input
            v-model="cpf_cnpj"
            type="txt"
            size="lg"
            class="custom-select custom-select-sm"
            placeholder="CPF/CNPJ"
            name="min-risck"
            id="min-risck"
          />
        </b-form-group>
      </div>
      <div class="col-12 col-md-6">
        <b-form-group label="Email da Compra">
          <input
            v-model="email"
            type="text"
            size="lg"
            class="custom-select custom-select-sm"
            placeholder="E-mail"
            name="min-risck"
            id="min-risck"
          />
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <b-form-group label="ID do Produto">
          <input
            v-model="id_product"
            type="txt"
            size="lg"
            class="custom-select custom-select-sm"
            placeholder="ID do Produto"
            name="min-risck"
            id="min-risck"
          />
        </b-form-group>
      </div>
      <div class="col-12 col-md-6">
        <b-form-group label="E-mail do Vendedor">
          <input
            v-model="email_seller"
            type="text"
            size="lg"
            class="custom-select custom-select-sm"
            placeholder="E-mail do Vendedor"
            name="min-risck"
            id="min-risck"
          />
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <b-form-group label="ID da Venda">
          <input
            v-model="id_venda"
            type="txt"
            size="lg"
            class="custom-select custom-select-sm"
            placeholder="ID da Venda"
            name="min-risck"
            id="min-risck"
          />
        </b-form-group>
      </div>
      <div class="col-12 col-md-6">
        <b-form-group label="Telefone da Compra">
          <input
            v-model="cellphone"
            type="text"
            size="lg"
            class="custom-select custom-select-sm"
            placeholder="Telefone da Compra"
            name="min-risck"
            id="min-risck"
          />
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <b-form-group label="Data da Venda">
          <date-range-picker
            id="range"
            ref="picker"
            v-model="date"
            class="w-100"
            :locale-data="localeDate"
            :show-week-numbers="false"
            :show-dropdowns="true"
            :auto-apply="false"
            :ranges="dateRanges"
          >
            <template
              v-if="date.startDate && date.endDate"
              v-slot:input="picker"
            >
              {{ picker.startDate | date }} - {{ picker.endDate | date }}
            </template>
            <template v-else v-slot:input> Período </template>
          </date-range-picker>
        </b-form-group>
      </div>
      <div class="col-12 col-md-6">
        <b-form-group label="Data da Análise">
          <date-range-picker
            id="range"
            ref="picker2"
            v-model="date2"
            class="w-100 fix-not-center"
            :locale-data="localeDate2"
            :show-week-numbers="false"
            :show-dropdowns="true"
            :auto-apply="false"
            :ranges="dateRanges2"
          >
            <template
              v-if="date2.startDate && date2.endDate"
              v-slot:input="picker2"
            >
              {{ picker2.startDate | date }} - {{ picker2.endDate | date }}
            </template>
            <template v-else v-slot:input> Período </template>
          </date-range-picker>
        </b-form-group>
      </div>
    </div>

    <template v-slot:modal-footer="{ cancel }">
      <b-button variant="secondary" @click="cancel">Cancelar</b-button>
      <b-button variant="success" @click="onSubmit2">Limpar Filtros</b-button>
      <b-button variant="success" @click="onSubmit">Ok</b-button>
    </template>
  </b-modal>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import moment from 'moment'


export default {
  components: {
    DateRangePicker,
  },
  data() {
    return {
      risck: [null, null],
      score: [null, null],
      ip: null,
      hash: null,
      cellphone: null,
      id_venda: null,
      cpf_cnpj: null,
      id_product: null,
      email_seller: null,
      email: null,
      date: {
        startDate: null,
        endDate: null,
      },
      date2: {
        startDate: null,
        endDate: null,
      },
      localeDate: {
        direction: 'ltr',
        format: 'mm/dd/yyyy',
        separator: ' - ',
        applyLabel: 'Aplicar',
        cancelLabel: 'Cancelar',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ],
        firstDay: 0,
      },
            localeDate2: {
        direction: 'ltr',
        format: 'mm/dd/yyyy',
        separator: ' - ',
        applyLabel: 'Aplicar',
        cancelLabel: 'Cancelar',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: [
          'Jan',
          'Fev',
          'Mar',
          'Abr',
          'Mai',
          'Jun',
          'Jul',
          'Ago',
          'Set',
          'Out',
          'Nov',
          'Dez',
        ],
        firstDay: 0,
      },

      status2: [null],
      options_sale:[
            { value: null, text: 'Todos os status' },
            { value: 'chargedback', text: 'Chargedback' },
            { value: 'completed', text: 'Completa' },
            { value: 'created', text: 'Criada' },
            { value: 'delayed', text: 'Em processamento' },
            { value: 'paid', text: 'Paga' },
            { value: 'refund_pending', text: 'Solicitação de reembolso' },
            { value: 'refunded', text: 'Reembolsada' },
            { value: 'refused', text: 'Recusada' },
          ],
      status: [null],
      options: [
        { value: null, text: 'Todos os status' },
        { value: 'FRAUD', text: 'fraude' },
        { value: 'FALSE_ALARM', text: 'alarme falso' },
        { value: 'IN_OPEN', text: 'em aberto' },
      ],
      optionsSeller: [{ value: null, text: 'Todos' }],
    }
  },
  computed: {
    dateRanges() {
      let today = new Date()
      today.setHours(0, 0, 0, 0)

      let yesterday = new Date()
      yesterday.setDate(today.getDate() - 1)
      yesterday.setHours(0, 0, 0, 0)

      let lastWeek = new Date()
      lastWeek.setDate(today.getDate() - 7)
      lastWeek.setHours(0, 0, 0, 0)

      return {
        Hoje: [today, today],
        Ontem: [yesterday, yesterday],
        'Última semana': [lastWeek, today],
        'Este mês': [
          new Date(today.getFullYear(), today.getMonth(), 1),
          new Date(today.getFullYear(), today.getMonth(), 30),
        ],
        'Este ano': [
          new Date(today.getFullYear(), 0, 1),
          new Date(today.getFullYear(), 11, 31),
        ],
        'Último mês': [
          new Date(today.getFullYear(), today.getMonth() - 1, 1),
          new Date(today.getFullYear(), today.getMonth(), 0),
        ],
      }
    },
    dateRanges2() {
      let today = new Date()
      today.setHours(0, 0, 0, 0)

      let yesterday = new Date()
      yesterday.setDate(today.getDate() - 1)
      yesterday.setHours(0, 0, 0, 0)

      let lastWeek = new Date()
      lastWeek.setDate(today.getDate() - 7)
      lastWeek.setHours(0, 0, 0, 0)

      return {
        Hoje: [today, today],
        Ontem: [yesterday, yesterday],
        'Última semana': [lastWeek, today],
        'Este mês': [
          new Date(today.getFullYear(), today.getMonth(), 1),
          new Date(today.getFullYear(), today.getMonth(), 30),
        ],
        'Este ano': [
          new Date(today.getFullYear(), 0, 1),
          new Date(today.getFullYear(), 11, 31),
        ],
        'Último mês': [
          new Date(today.getFullYear(), today.getMonth() - 1, 1),
          new Date(today.getFullYear(), today.getMonth(), 0),
        ],
      }
    },

  },
  methods: {
    onSubmit() {
      const status = this.status && this.status[0] ? this.status : null;
      const status2 = this.status2 && this.status2[0] ? this.status2 : null;
      let data = {
        status: status,
        status_sale: status2,
        risk_start: this.risck[0],
        risk_end: this.risck[1],
        score_start: this.score[0],
        score_end: this.score[1],
        ip: this.ip,
        hash: this.hash,
        cellphone: this.cellphone,
        id_sale: this.id_venda,
        cpf_cnpj: this.cpf_cnpj,
        id_product: this.id_product,
        email_seller: this.email_seller,
        email: this.email,
      }

      if(this.date.startDate && this.date.endDate){
        data.sale_date_start = this.date.startDate
            ? moment(this.date.startDate).format('YYYY-MM-DD')
            : null;

        data.sale_date_end = this.date.endDate
          ? moment(this.date.endDate).format('YYYY-MM-DD')
          : null;

      }

      if(this.date2.startDate && this.date2.endDate){
        data.date_end = this.date2.endDate
          ? moment(this.date2.endDate).format('YYYY-MM-DD')
          : null;

        data.date_start = this.date2.startDate
          ? moment(this.date2.startDate).format('YYYY-MM-DD')
          : null;

      }

      this.$emit('close', data)
      this.$bvModal.hide('modal-filters')
    },
    onSubmit2() {
      let data = {}

      this.risck = [0, 100]
      this.score = [0, 1000]
      this.ip = null
      this.hash = null
      this.cellphone = null;
      this.id_venda = null;
      this.cpf_cnpj = null;
      this.id_product = null;
      this.email_seller = null;
      this.email = null;
      this.date = {
        startDate: null,
        endDate: null,
      }
      this.date2 = {
        startDate: null,
        endDate: null,
      }
      this.status = [null];
      this.status2 = [null];

      this.$emit('close', data)
      this.$bvModal.hide('modal-filters')
    },
  },
}
</script>

<style scoped>
.grid-iputs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}
</style>